import axios from 'axios';
import { useEffect, useState } from 'react';
import { app } from '../../config';
import getHeaders from '../../utils/authHeaders';

// import getHeaders from '../utils/authHeaders';

const singleFaqDetail = (id) => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('entered');
    const fetchData = async () => {
      try {
        const res = await axios.get(`${app.URL}/api/v1/admin/faqs/view/${id}`, { headers: getHeaders() });

        console.log('response is : ', res);

        console.log(res.data.result.data);
        setResponse(res.data.result.data);
      } catch (err) {
        setError(err);
      }
    };
    fetchData();
  }, []);

  return { response, error };
};

export default singleFaqDetail;
